import React, { useEffect, useState } from "react";
import { PageHeader, MyTextInput } from "@excoleadershipui/pionweblib";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { countries, continents } from "countries-list";
// material ui
import {
  Box,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  FormHelperText,
  Grid,
  Autocomplete,
  TextField as MuiTextField
} from "@mui/material";
// icons
import CancelIcon from "@mui/icons-material/Cancel";
// components
import { FormSubmitButton, CommonCurdPopUp, MuiAutocomplete } from "../../../components";
import Notifier from "../../../components/common/Notifier";
import ErrorNotifier from "../../../components/common/ErrorNotifier";
// redux
import {
  updateQuestionType,
  getQuestionType,

} from "../../../features/config/questionTypeSlice";
import { getUserGroupsChr, } from '../../../features/iam_chr/role_management/userGroupsSlice'
import { getRolesChr } from "../../../features/iam_chr/role_management/rolesSlice";
import { getAccountChr, updateAccountChr, resetMessage, resetErrMessage } from "../../../features/auth/authChrSlice";

// --------------------------------------------------------------

const validationSchema = Yup.object({
  questionType: Yup.string().required("Question Type is required"),
  responseType: Yup.string().required("Response Type is required"),
  comments: Yup.string(),
});

//   ------------------------------------------------------------------------------------------

const UpdateChrUserdetails = (props) => {

  const [countryArr, setCountryArr] = useState([])
  const [selectedData, setSelectedData] = useState(props?.selectedData)
  const [rolesArr, setRolesArr] = useState([])
  const [secondaryRolesArr, setSecondaryRolesArr] = useState([])
  const [showEdit, setShowEdit] = useState(false);

  const { message, errMessage } = useSelector((state) => ({ ...state.authChr }))
  const { userGroupsData } = useSelector((state) => ({ ...state.userGroupsChr }))
  const { rolesData } = useSelector((state) => ({ ...state.rolesChr }))
  const { customersData } =
    useSelector((state) => ({ ...state.customer }));


  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      questionType: selectedData?.questionTypeName,
      responseType: selectedData?.responseType,
      comments: selectedData?.comments,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      dispatch(
        updateQuestionType({
          id: selectedData.id,
          questionTypeName: values.questionType,
          responseType: values.responseType,
          comments: values.comments,
        })
      ).then((res) => {
        if (res?.payload?.data?.ok) {
          setTimeout(() => {
            dispatch(resetMessage());
            props.close();
            dispatch(getQuestionType());
          }, 2000);
        }
        if (res?.payload?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 3000);
        }
      });
    },
  });

  const editValidationSchema = Yup.object({
    firstName: Yup.string("Enter your First Name").required(
      "First Name is required"
    ),
    lastName: Yup.string("Enter your Last Name").required(
      "Last Name is required"
    ),
    geography: Yup.string().required("Geo Name is required"),
    country: Yup.string().required("country is required "),
    userGroup: Yup.array().min(1, "User Group is required").required("User Group is required"),
    primaryRole: Yup.object().nullable().required("Primary Role is required"),
    // secondaryRoles: Yup.array("Enter your Secondary Roles").required("Secondary Roles is required"),
    // email: Yup.string("Enter your email")
    //   .required("Email is required")
    //   // .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "email is not valid"),
    //   .email("Email is not valid"),
    dialingCode: Yup.string().required("DialingCode is required"),
    contactNumber: Yup.string()
      .required("Contact Number is required ")
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
    // comments: Yup.string().nullable(),
  });

  // const closeEditModal = () => {
  //   setShowEdit(false);
  // };




  const formikEdit = useFormik({
    enableReinitialize: true,
    initialValues: {
      customerName: selectedData?.assessmentUserChr?.assessmentCustomer?.id,

      firstName: selectedData?.firstName,
      lastName: selectedData?.lastName,
      email: selectedData?.assessmentUserChr?.email,
      userGroup: typeof selectedData?.assessmentUserRoleChr !== "undefined" && selectedData?.assessmentUserRoleChr?.length > 0 ? [...new Map(selectedData.assessmentUserRoleChr.map(item => [item.userRoleChr?.userGroupChr['id'], item.userRoleChr?.userGroupChr])).values()].map(item => item) : [],
      primaryRole: typeof selectedData?.assessmentUserRoleChr !== "undefined" && selectedData?.assessmentUserRoleChr?.length > 0 ? selectedData.assessmentUserRoleChr?.filter(item => item.isPrimary === true).map(value => value.userRoleChr)[0] : "",
      secondaryRoles: typeof selectedData?.assessmentUserRoleChr !== "undefined" && selectedData?.assessmentUserRoleChr?.length > 0 ? selectedData.assessmentUserRoleChr?.filter(item => item.isPrimary === false).map(value => value?.userRoleChr) : "",
      geography: selectedData?.geoName,
      country: selectedData?.country,
      dialingCode: selectedData?.dialingCode,
      contactNumber: selectedData?.contactNumber,
      comments: selectedData?.comments,
    },

    validationSchema: editValidationSchema,
    onSubmit: (values) => {
      console.log("update Api hitted")

      let data = {
        excoCustomerId: selectedData?.assessmentCustomer?.id,
        id: selectedData?.assessmentUserChr?.id,
        firstName: values?.firstName,
        lastName: values?.lastName,
        email: values?.email,
        userGroupChrId: values?.userGroup.map(item => item.id),
        primaryUserRoleChrId: values?.primaryRole?.id,
        secondaryUserRoleChrId: values?.secondaryRoles.map(item => item.id),
        geoName: values?.geography,
        country: values?.country,
        dialingCode: values?.dialingCode,
        contactNumber: values?.contactNumber.toString(),
        comments: values?.comments,
      };

      dispatch(updateAccountChr(data)).then((res) => {
        if (res?.payload?.data?.ok) {
          setTimeout(() => {
            dispatch(resetMessage());
            dispatch(getAccountChr());
            props.back()
            // closeEditModal();
          }, 2000);
        }
        if (res?.payload?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());

          }, 3000);
        }
      });
    },
  });

  useEffect(() => {
    if (formikEdit.values?.userGroup?.length === 0) {
      formikEdit.setFieldValue('primaryRole', "")
      formikEdit.setFieldValue('secondaryRoles', [])
    }
    else {
      // Filter secondaryRoles based on selected userGroup
      const filteredSecondaryRoles = formikEdit.values.secondaryRoles.filter(role =>
        formikEdit.values.userGroup.some(group => group.id === role.userGroupChr.id)
      );
      const isPrimaryRoleValid = formikEdit.values.userGroup.some(group =>
        group.id === formikEdit?.values?.primaryRole?.userGroupChr?.id
      );

      // If primaryRole is not valid, reset it
      const updatedPrimaryRole = isPrimaryRoleValid ? formikEdit.values.primaryRole : "";

      formikEdit.setFieldValue('secondaryRoles', filteredSecondaryRoles);
      formikEdit.setFieldValue('primaryRole', updatedPrimaryRole)
    }
    let roles = []
    rolesData?.length > 0 && rolesData?.map((option) => {
      formikEdit?.values?.userGroup?.length > 0 && formikEdit?.values?.userGroup?.map(item => {
        if (option?.userGroupChr?.id === item.id) {
          return roles.push(option)
        }
      })

      setRolesArr(roles)
    });
  }, [formikEdit?.values?.userGroup]);

  useEffect(() => {
    let secondaryRoles = []

    rolesData?.length > 0 && rolesData?.map((option) => {
      formikEdit?.values?.userGroup.length > 0 && formikEdit?.values?.userGroup.map(item => {
        if (option?.userGroupChr?.id === item.id) {
          if (option?.id !== formikEdit.values.primaryRole?.id) {
            return secondaryRoles.push(option)
          }
        }
      })
      setSecondaryRolesArr(secondaryRoles)
    });
    showEdit && formikEdit.setFieldValue("secondaryRoles", [])
  }, [formikEdit?.values?.primaryRole, formikEdit?.values?.userGroup]);

  useEffect(() => {

    if (!formikEdit?.values?.country) {
      formikEdit?.setFieldValue("dialingCode", "")
    }
    options.map((option) => {

      if (option.name === formikEdit?.values?.country) {
        return formikEdit?.setFieldValue("dialingCode", option?.phone);
      }
    });
  }, [formikEdit?.values?.country]);


  useEffect(() => {
    dispatch(getAccountChr());
    dispatch(getUserGroupsChr())
    dispatch(getRolesChr());
  }, []);

  let options = Object.values(countries);

  console.log(customersData)
  console.log(selectedData?.
    assessmentUserChr?.assessmentCustomer)

  console.log(secondaryRolesArr);
  console.log(rolesArr)
  console.log(userGroupsData)
  console.log(formikEdit.values.userGroup)
  return (
    <>

      {props?.showEdit && <CommonCurdPopUp
        heading={`Update User`}
        mediumScreen={true}
        close={
          props?.back
        }
      >
        <Grid container >
          <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
          <Grid spacing={1} container item xs={12} sm={12} md={11} >
            <Grid item xs={12} sm={12} md={12}>
              <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                <InputLabel id="demo-simple-select-label">Customer Name</InputLabel>
                <Select
                  tabIndex={1}
                  disabled
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="geography"

                  value={formikEdit.values.customerName}
                  label="Geography"
                // onChange={formikEdit.handleChange}
                >
                  {customersData?.map((item) => (
                    <MenuItem key={item?.id} value={item?.id}>
                      {item.customerName}
                    </MenuItem>
                  ))}
                </Select>
                {/* <FormHelperText error={true} sx={{ color: "red" }}>
                  {formikEdit.touched.geography && formikEdit.errors.geography}
                </FormHelperText> */}
              </FormControl>

              {/* <MuiAutocomplete

                name="customerName"
                options={customersData}
                setValue={(name, newValue) => {

                  formik.setFieldValue(name, newValue)
                 

                }
                }
                value={formik.values.customerName}
                optionValue="customerName"
                label="Customer"
                required={true}
                error={formik.touched.customerName && Boolean(formik.errors.customerName)}
                helperText={formik.touched.customerName && formik.errors.customerName}
              /> */}
            </Grid>
            <Grid item xs={12} sm={12} md={6}>



              <div style={{ display: "flex" }}>
                <div style={{ paddingRight: "0.5rem" }}>
                  <MyTextInput
                    tabIndex="2"
                    label="First Name"
                    type="text"
                    name="firstName"
                    required={true}
                    margin="normal"
                    id="firstName"
                    value={formikEdit.values.firstName}
                    onChange={formikEdit.handleChange}
                    error={
                      formikEdit.touched.firstName &&
                      Boolean(formikEdit.errors.firstName)
                    }
                    helperText={
                      formikEdit.touched.firstName && formikEdit.errors.firstName
                    }
                  />
                </div>
                <div>
                  <MyTextInput
                    tabIndex="3"
                    label="Last Name"
                    type="text"
                    name="lastName"
                    required={true}
                    margin="normal"
                    id="lastName"
                    value={formikEdit.values.lastName}
                    onChange={formikEdit.handleChange}
                    error={
                      formikEdit.touched.lastName &&
                      Boolean(formikEdit.errors.lastName)
                    }
                    helperText={
                      formikEdit.touched.lastName && formikEdit.errors.lastName
                    }
                  />
                </div>
              </div>
              <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                <InputLabel id="demo-simple-select-label">Geography *</InputLabel>
                <Select
                  tabIndex={5}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="geography"
                  defaultValue={formikEdit?.values?.geography}
                  value={formikEdit.values.geography}
                  label="Geography"
                  onChange={formikEdit.handleChange}
                >
                  {Object.keys(continents).map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}-{continents[item]}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText error={true} sx={{ color: "red" }}>
                  {formikEdit.touched.geography && formikEdit.errors.geography}
                </FormHelperText>
              </FormControl>
              <Autocomplete
                name="userGroup"
                multiple
                id="tags-outlined"
                options={Array.isArray(userGroupsData) ? userGroupsData : []}
                getOptionLabel={(option) => option?.groupName || ""}
                value={formikEdit.values.userGroup || []} // Ensure value is always an array
                onChange={(event, newValue) =>
                  formikEdit.setFieldValue("userGroup", Array.isArray(newValue) ? newValue : [])
                }
                renderInput={(params) => (
                  <MuiTextField
                    {...params}
                    label="User Group"
                    required
                    error={formikEdit.touched.userGroup && Boolean(formikEdit.errors.userGroup)}
                    helperText={formikEdit.touched.userGroup && formikEdit.errors.userGroup}
                  />
                )}
                sx={{ marginTop: "1rem" }}
                disabled={userGroupsData.length === 0}
              />

              <Autocomplete
                name="secondaryRoles"
                multiple
                id="tags-outlined"
                filterSelectedOptions
                options={Array.isArray(secondaryRolesArr) ? secondaryRolesArr : []}
                getOptionLabel={(option) => Object.keys(option)?.length > 0 ? `${option["roleCode"]}-${option["roleName"]}` : ""}
                value={formikEdit.values.secondaryRoles}
                onChange={(event, newValue) => formikEdit.setFieldValue("secondaryRoles", newValue)}
                renderInput={(params) => (
                  <MuiTextField
                    {...params}
                    label="Secondary Roles"
                    error={formikEdit.touched.secondaryRoles && Boolean(formikEdit.errors.secondaryRoles)}
                    helperText={formikEdit.touched.secondaryRoles && formikEdit.errors.secondaryRoles}
                  />
                )}
                sx={{ marginTop: "1rem" }}
                disabled={secondaryRolesArr.length === 0}
              />
              <MyTextInput
                label="Comments"
                type="text"
                name="comments"
                fullWidth={true}
                margin="normal"
                id="comments"
                value={formikEdit.values.comments}
                onChange={formikEdit.handleChange}
                error={
                  formikEdit.touched.comments &&
                  Boolean(formikEdit.errors.comments)
                }
                helperText={
                  formikEdit.touched.comments && formikEdit.errors.comments
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <MyTextInput
                tabIndex={4}
                label="Email"
                type="email"
                name="email"
                required={true}
                fullWidth={true}
                margin="normal"
                id="email"
                value={formikEdit.values.email}
                onChange={formikEdit.handleChange}
                disabled={true}
                error={
                  formikEdit.touched.email && Boolean(formikEdit.errors.email)
                }
                helperText={formikEdit.touched.email && formikEdit.errors.email}
              />
              <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                <InputLabel id="demo-simple-select-label">Country *</InputLabel>
                <Select
                  tabIndex="6"

                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="country"
                  defaultValue={formikEdit?.values?.country}
                  value={formikEdit.values.country}
                  label="Country"
                  onChange={formikEdit.handleChange}
                >
                  {options.map((option) => {
                    if (formikEdit.values.geography === option.continent) {
                      return (
                        <MenuItem key={option.name} value={option.name}>
                          {option.name}
                        </MenuItem>
                      );
                    }
                  })}
                </Select>
                <FormHelperText error={true} sx={{ color: "red" }}>
                  {formikEdit.touched.country && formikEdit.errors.country}
                </FormHelperText>
              </FormControl>
              <Autocomplete
                name="primaryRole"
                id="tags-outlined"
                options={Array.isArray(rolesArr) ? rolesArr : rolesArr}
                getOptionLabel={(option) => Object.keys(option).length > 0 ? `${option["roleCode"]}-${option["roleName"]}` : ""}
                value={formikEdit.values.primaryRole}
                onChange={(event, newValue) => formikEdit.setFieldValue("primaryRole", newValue)}
                renderInput={(params) => (
                  <MuiTextField
                    {...params}
                    label="Primary Role"
                    required={true}
                    error={formikEdit.touched.primaryRole && Boolean(formikEdit.errors.primaryRole)}
                    helperText={formikEdit.touched.primaryRole && formikEdit.errors.primaryRole}
                  />
                )}
                sx={{ marginTop: "1rem" }}
                disabled={rolesArr.length === 0}
              />
              <div style={{ display: "flex" }}>
                <div style={{ width: "35%", paddingRight: "0.5rem" }}>
                  <MyTextInput
                    label="Dialing Code"
                    type="number"
                    name="dialingCode"
                    required={true}
                    fullWidth={true}
                    margin="normal"
                    id="dialingCode"
                    value={formikEdit.values.dialingCode}
                    disabled
                    error={
                      formikEdit.touched.dialingCode &&
                      Boolean(formikEdit.errors.dialingCode)
                    }
                    helperText={
                      formikEdit.touched.dialingCode &&
                      formikEdit.errors.dialingCode
                    }
                  />
                </div>
                <div style={{ width: "65%" }}>
                  <MyTextInput
                    label="Contact Number"
                    type="number"
                    name="contactNumber"
                    required={true}
                    fullWidth={true}
                    margin="normal"
                    id="contactNumber"
                    value={formikEdit.values.contactNumber}
                    onChange={formikEdit.handleChange}
                    tabIndex={10}
                    error={
                      formikEdit.touched.contactNumber &&
                      Boolean(formikEdit.errors.contactNumber)
                    }
                    helperText={
                      formikEdit.touched.contactNumber &&
                      formikEdit.errors.contactNumber
                    }
                  />
                </div>
              </div>

            </Grid>

            <Box style={{ width: "100%", textAlign: "center" }} >

              <FormSubmitButton onClick={formikEdit?.handleSubmit} type="submit" variant="contained"
              >
                Submit
              </FormSubmitButton>
            </Box>
          </Grid>
        </Grid>


      </CommonCurdPopUp>}
      {message && <Notifier message={message} />}
      {errMessage && <ErrorNotifier message={errMessage} />}

    </>
  );
};

export default UpdateChrUserdetails;
